import { ReactNode, useContext } from 'react';
import * as EmptySectionContent from 'src/components/common/EmptySectionContent';
import {
  AdCampaignsDataContext,
  useAdCampaignsDataContext,
} from 'src/contexts/AdCampaignsDataContext/AdCampaignsDataContext';
import { Content, useContent } from 'src/contexts/ContentContext';
import { DialogProvider } from 'src/contexts/DialogContext/DialogContext';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { Stack } from 'src/core/ui';
import { LayoutContent } from 'src/navigations/LayoutContent';
import { SearchSolidIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { SomethingWentWrong } from 'src/views';

import { MainRoute } from '../MainRoute';
import { AdCampaignsToolbar } from './AdCampaignsToolbar/AdCampaignsToolbar';

export function SponsoredListings() {
  return <SponsoredListingsContent />;
}

function SponsoredListingsContent() {
  const sponsoredListingsTitle = useContent(ContentId.SponsoredListings);

  const { adCampaignsDataQuery: adCampaignsDataQuery, errorInfo } = useContext(
    AdCampaignsDataContext
  );

  return (
    <DialogProvider>
      <LayoutContent
        mainRoute={MainRoute.SponsoredListings}
        routeTitle={sponsoredListingsTitle}
      >
        <Stack direction="column" width="full" height="full">
          {adCampaignsDataQuery.isLoading && <PosSpinner />}
          {errorInfo && (
            <SomethingWentWrong
              header={errorInfo.errorHeader}
              message={
                errorInfo.errorMessage ?? (
                  <Content id={ContentId.FailToLoadListContent} />
                )
              }
            />
          )}
          {!adCampaignsDataQuery.isLoading && !errorInfo && (
            <>
              <AdCampaignsToolbar />
              <EmptySectionContent.Root
                icon={
                  <EmptySectionContent.SolidIconContainer>
                    <SearchSolidIcon />
                  </EmptySectionContent.SolidIconContainer>
                }
              >
                <EmptySectionContent.Label>
                  <Content id={ContentId.NoResultFound} />
                </EmptySectionContent.Label>
                <EmptySectionContent.DetailMessage>
                  <Content id={ContentId.NoEventsMatching} />
                </EmptySectionContent.DetailMessage>
              </EmptySectionContent.Root>
            </>
          )}
        </Stack>
      </LayoutContent>
    </DialogProvider>
  );
}

type AdCampaignsFlattenedViewProps = {
  before?: ReactNode;
  topListItemBefore?: ReactNode;
};

export const AdCampaignsFlattenedView = ({
  before,
  topListItemBefore,
}: AdCampaignsFlattenedViewProps) => {
  const { adCampaignsDataQuery: campaignDataQuery, allCampaignData } =
    useAdCampaignsDataContext();

  return (
    <Stack direction="column" height="full" width="full">
      {before}
      {topListItemBefore}
    </Stack>
  );
};
